import dayjs from '~/timeInit';

/**
 * Salesforce surcharges and admin's `surcharge_date_block` records both treat
 * `start_date` and `end_date` as INCLUSIVE — `end_date` is the last day the
 * surcharge applies. The boundary-sweep splitting algorithm in
 * `resolveSurchargeOverlaps`, and the overlap detection in
 * `surchargeOverlapAnalysis`, both operate in half-open `[start, endExclusive)`
 * space internally and convert at the I/O edges via the helpers below.
 *
 * Why half-open internally:
 *   The boundary-sweep approach treats every distinct date that is either a
 *   `start_date` or an `end_date + 1 day` as a single transition point — a
 *   scalar that means both "previous segment ends here" and "next segment
 *   starts here". Half-open intervals express that naturally, and we can reuse
 *   the shared `rangeOverlap` helper (which already uses strict `<`).
 *
 *   In inclusive space we'd still need a `+1 day` hop between adjacent
 *   segments (the day after one surcharge ends is the day the next starts), so
 *   the conversion is unavoidable — the question is only where it lives.
 *   Centralising it at the function boundary keeps the algorithm readable and
 *   prevents `± 1 day` arithmetic from leaking into every comparison.
 */
export const toExclusiveEnd = (endDate: string): string => dayjs(endDate).add(1, 'day').format('YYYY-MM-DD');

export const toInclusiveEnd = (endExclusive: string): string =>
  dayjs(endExclusive).subtract(1, 'day').format('YYYY-MM-DD');
